<template>
  <footer class="footer">
    <div class="container footer-content">
      <div class="row footer-top">
        <div class="col-sm-6 col-xl-3 footer-top-contact">
          <h3>Contact Us</h3>
          <div class="hr"></div>

          <address class="mb-0">
            <p>Contact our team via:</p>

            <div>
              <a href="mailto:info@rococopainters.co.uk"
                >info@rococopainters.co.uk</a
              >
              <a href="tel:07904155651">07904 155651</a>
            </div>

            <p>
              Evolution House <br />
              Iceni Court <br />
              Delft Way <br />
              Norwich, Norfolk <br />
              NR6 6BB
            </p>
          </address>
        </div>

        <div class="col-sm-6 col-xl-3 mt-5 mt-sm-0 footer-top-navigation">
          <h3>Sections</h3>
          <div class="hr"></div>
          <ul>
            <li>
              <router-link class="footer-top-navigation-link" to="/about-us/">
                About Us
              </router-link>
            </li>
            <li>
              <router-link
                class="footer-top-navigation-link"
                to="/our-services/"
                >Services</router-link
              >
            </li>
            <li>
              <router-link
                class="footer-top-navigation-link"
                to="/gallery/"
              >
                Gallery
              </router-link>
            </li>
            <li>
              <router-link
                class="footer-top-navigation-link"
                to="/testimonials/"
              >
                Testimonials
              </router-link>
            </li>
            <li>
              <router-link class="footer-top-navigation-link" to="/contact-us/"
                >Contact Us</router-link
              >
            </li>
          </ul>
        </div>

        <div class="col-sm-6 col-xl-3 mt-5 mt-xl-0 footer-top-social">
          <h3>Follow Us</h3>
          <div class="hr"></div>
          <div class="footer-top-social-links">
            <a
              target="_blank"
              class="footer-top-social-link"
              rel="noopener noreferrer"
              href="https://www.facebook.com/Dannyjayvos/?locale=en_GB"
            >
              <font-awesome-icon :icon="faFacebookF" size="lg" />
              <span>Facebook</span>
            </a>
            <a
              target="_blank"
              class="footer-top-social-link"
              rel="noopener noreferrer"
              href="https://www.instagram.com/rococo_painters_ltd/"
            >
              <font-awesome-icon :icon="faInstagram" size="lg" />
              <span>Instagram</span>
            </a>
          </div>
        </div>

        <div class="col-sm-6 col-xl-3 mt-5 mt-xl-0 footer-top-legal">
          <h3>Legal</h3>
          <div class="hr"></div>
          <ul>
            <li>
              <router-link
                class="footer-top-navigation-link"
                to="/privacy-cookie-policy/"
              >Privacy & Cookie Policy</router-link>
            </li>
          </ul>
        </div>
      </div>

    </div>

    <div class="container-fluid footer-bottom">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <p class="footer-bottom-copyright">
              Copyright {{ copyrightDate }} &copy; Rococo Painters All
              Rights Reserved.
            </p>
          </div>

          <div class="col-lg-6">
            <p class="footer-bottom-nm-link">
              <a
                href="https://www.netmatters.co.uk"
                target="_blank"
                rel="noreferrer"
                >Website Design</a
              >&nbsp;by&nbsp;<a
                href="https://www.netmatters.co.uk"
                target="_blank"
                rel="noreferrer"
                >Netmatters</a
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faFacebookF, faInstagram } from '@fortawesome/free-brands-svg-icons'

export default {
  components: {
    FontAwesomeIcon
  },
  data () {
    return {
      name: 'main-footer',
      copyrightDate: '',
      faFacebookF,
      faInstagram
    }
  },
  mounted () {
    this.copyrightDate = new Date().getFullYear()
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/colors";
@import "../../assets/styles/variables/breakpoints";

.footer {
  background-color: $theme-primary-bg;
  color: $theme-primary-text;
  font-size: 0.875rem;

  .hr {
    width: 100px;
    height: 3px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 1rem;

    @media (min-width: $sm-breakpoint) {
      margin-left: 0;
      margin-right: 0;
    }

    background-color: $clr-theme-black;
  }

  h3 {
    letter-spacing: 0.02em;
  }

  p {
    font-size: 0.875rem;
    margin: 0;
  }

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  address {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    a {
      display: block;
    }
  }

  &-top {
    text-align: center;

    @media (min-width: $sm-breakpoint) {
      text-align: left;
    }

    p,
    a {
      font-weight: 500;
      color: inherit;
    }

    a,
    li {
      + * {
        margin-top: 0.5rem;
      }
    }

    &-social {
      display: flex;
      flex-direction: column;

      &-links {
        display: flex;
        flex-direction: column;
        gap: 0.75rem;
      }

      &-link {
        display: flex;
        gap: 1rem;
        align-items: center;
        justify-content: center;

        @media (min-width: $sm-breakpoint) {
          justify-content: normal;
        }

        &:hover {
          svg path {
            fill: lighten($clr-theme-black, 30%);
          }
        }

        svg path {
          fill: $clr-theme-black;
        }
      }
    }
  }

  &-content {
    padding-top: 38px;
    padding-bottom: 38px;

    display: flex;
    flex-direction: column;
    gap: 38px;
  }

  &-middle {
    p {
      font-weight: 400;
    }
  }

  &-bottom {
    background-color: $theme-primary-bg-shade;
    padding-top: 15px;
    padding-bottom: 15px;

    &-copyright {
      font-size: 13px;

      @media (max-width: $lg-breakpoint) {
        text-align: center;
      }
    }

    &-nm-link {
      font-size: 13px;
      text-align: right;

      @media (max-width: $lg-breakpoint) {
        text-align: center;
      }

      a {
        color: $theme-primary-text;
        text-decoration: underline;

        &:hover {
          color: $theme-primary-text !important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/MainFooter.vue